module.exports = __webpack_public_path__ + "img/Borussia-M-gladbach.c25e0507.png";